// Action types for UI
export const PAGE_UPDATE = 'PAGE_UPDATE';
export const ROWS_PER_PAGE_UPDATE = 'ROWS_PER_PAGE_UPDATE';
export const NINJAS_SELECTED = 'NINJAS_SELECTED';
export const NINJAS_ALL_SELECTED = 'NINJAS_ALL_SELECTED';
export const NINJAS_SEARCH_STRING = 'NINJAS_SEARCH_STRING';



/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/actions/action-types.js
 **/